import React, { Component } from 'react';

import { GlobalWrapper, SpMsg, Anchor, MyName } from 'components/StyledComponents';
import Header from 'components/Header';
import Writedown from 'components/Writedown';

class App extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <GlobalWrapper>
        <Header />
        <Writedown />
        <SpMsg>まだスマホに対応してません、、🙇</SpMsg>
        <MyName>
          <a href="https://syunsukekobashi.co/" target="_blank">
            @ksyunnnn
          </a>
        </MyName>
      </GlobalWrapper>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js